import { useParams } from 'react-router-dom';
import usePlaybook from '@/hooks/playbooks/usePlaybook';
import EntityBreadcrumb from '../EntityBreadcrumb';
import buildPlaybookBreadcrumbHref from './helpers/buildPlaybookBreadcrumbHref';
import resolvePlaybookBreadcrumbLabel from './helpers/resolvePlaybookBreadcrumbLabel';
import type { PlaybookCrumbProps } from './types';

const PlaybookCrumb = ({ param, isCurrentPage = false }: PlaybookCrumbProps) => {
    const params = useParams();
    const playbookId = params[param] || '';
    const versionId = params.versionId || null;
    const { playbook, isLoadingPlaybook } = usePlaybook({
        playbookId,
        enabled: playbookId.length > 0,
    });

    const label = resolvePlaybookBreadcrumbLabel({
        playbookId,
        playbookName: playbook?.name ?? null,
        isLoadingPlaybook,
    });

    return (
        <EntityBreadcrumb
            label={label}
            entityId={playbookId}
            entityType="Playbook"
            href={buildPlaybookBreadcrumbHref({ playbookId, versionId })}
            isCurrentPage={isCurrentPage}
            isLoading={isLoadingPlaybook && label === '...'}
        />
    );
};

export default PlaybookCrumb;
